/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathSumIcon20Light = forwardRef('MathSumIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.883 5.23c-.93-.734-.41-2.23.775-2.23H15.5a.5.5 0 0 1 0 1H4.658a.25.25 0 0 0-.155.446l5.785 4.573c.633.5.633 1.461 0 1.962l-5.785 4.573a.25.25 0 0 0 .155.446H15.5a.5.5 0 0 1 0 1H4.658c-1.185 0-1.705-1.496-.775-2.23l5.785-4.574a.25.25 0 0 0 0-.392L3.883 5.23Z" })));
});
